export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-11.1ed6f44b.jpg";